<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';

    export let taxiId = 0;
    export let closeCallback;

    let taxis = [];

    const load = () => {
        const onSuccess = result => {
            taxis = result;
        }

        const onFailure = err => {
        };

        const data = {
            is_active: 1,
            check_availability: 1,
        }

        R.handle(R.taxi.index, data, onSuccess, onFailure, LOADER.POPUP);
    }


    const onSelect = (taxi) => {
        close(taxi);
    }


    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        closeCallback(param);
        // setTimeout(() => {
        //     closeCallback(param);
        // }, 200);
    }

    load();
</script>
<Modal title="Select Taxi" on:close="{ close }">
    <div slot="body">
        <div class="remove-panel-pad">
            <table class="table table-list">
                <tbody>
                {#each taxis as taxi}
                    <tr class="row-hover pointer"
                        class:text-light={taxi.is_on_progress > 0}
                        class:text-danger={taxi.is_available == 0}
                        class:row-selected={ taxiId == taxi.id }
                        on:click={ () => onSelect(taxi) }>
                        <td class="px-2">{ taxi.taxi_number }</td>
                        <td class="px-2">{ taxi.licence_no }</td>
                        <td class="px-2">
                            {#if taxi.driver}
                                { taxi.driver.name }
                            {/if}
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
            <hr class="mt-0">
        </div>
        <div class="text-end">
            <button class="btn btn-link" on:click={ close }>Cancel</button>
        </div>
    </div>
</Modal>
